import React, { useState } from "react";

export default function InvestorExpandable({ title, subtitle, badge, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`investor-expandable${open ? " investor-expandable--open" : ""}`}>
      <button
        type="button"
        className="investor-expandable__trigger"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <div className="investor-expandable__lead">
          <div className="investor-expandable__title">{title}</div>
          {subtitle ? <div className="investor-expandable__subtitle">{subtitle}</div> : null}
        </div>
        <span className="investor-expandable__meta">
          {badge}
          <span className="investor-expandable__chevron" aria-hidden>
            ▾
          </span>
        </span>
      </button>
      {open ? <div className="investor-expandable__body">{children}</div> : null}
    </div>
  );
}
